import { render, staticRenderFns } from "./info.vue?vue&type=template&id=a0537026&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=a0537026&lang=scss&scoped=true&"
import style1 from "./info.vue?vue&type=style&index=1&id=a0537026&scoped=true&lang=css&"
import style2 from "./info.vue?vue&type=style&index=2&id=a0537026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0537026",
  null
  
)

export default component.exports